import React from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";

const educationData = [
  {
    id: 1,
    title: "Front-end",
    years: "2020 - presente",
    content:
      "HTML, CSS, JS y React JS en Udemy y FreeCodeCamp",
  },
  {
    id: 2,
    title: "Manicure integral",
    years: "2019",
    content:
      "Luxury Nails Factory con Fanny Salinas. Santiago",

  },
  {
    id: 3,
    title: "Maquillaje editorial",
    years: "2016",
    content:
      "The Collective con Marcelo Bhanu. Santiago.",
  },
  {
    id: 4,
    title: "Maquillaje profesional",
    years: "2012",
    content:
      "Academia Carmen Vidal. Caracas.",
  },
  
  
];

const experienceData = [
  {
    id: 1,
    title: "El Espacio de Belleza SPA",
    years: "2018 - 2020",
    content:
      "Creadora del primer salón de belleza cruelty-free",
  },
  {
    id: 2,
    title: "Maquilladora CNN Chle",
    years: "2014 - 2016",
    content:
      "Maquillaje y estilismo de planta para el canal de noticias CNN chile.",
  },
  {
    id: 3,
    title: "Maquilladora freelance",
    years: "2012 - presente",
    content:
      "Servicio de maquillaje social, fotografía, publicidad, tv, etc.",
  },
];

function Experiences() {
  return (
    <section id="experience">
      <div className="container">
        <Pagetitle title="Educación y Experiencia" />
        <div className="row">
          <div className="col-md-6">
            <div className="timeline edu bg-white rounded shadow-dark padding-30 overflow-hidden">
              {educationData.map((education) => (
                <Timeline key={education.id} education={education} />
              ))}
              <span className="line"></span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
            <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
              {experienceData.map((experience) => (
                <Timeline key={experience.id} education={experience} />
              ))}
              <span className="line"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experiences;
